module.exports = __webpack_public_path__ + "static/media/viewall.6cd46810.svg";